'use strict';

var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');
var CustomizeContext = require('./CustomizeContext-CpkrEQ6Z.js');
var Header = require('./Header-wk4mHKME.js');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
var RadioGroup = require('@swiggy-private/dls-web-core/dist/components/RadioGroup');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var utils = require('./utils-CqsSjtb2.js');
var styled = require('styled-components');
var Button = require('@swiggy-private/dls-web-core/dist/components/Button');
var CardContainer = require('@swiggy-private/dls-web-core/dist/components/CardContainer');
var components_Customise_constants_index = require('./components/Customise/constants/index.js');
var Checkbox = require('@swiggy-private/dls-web-core/dist/components/Checkbox');
var PartialList = require('./PartialList-Cdl4XIGT.js');
var ScreenReaderOnly = require('./ScreenReaderOnly-Bo2uWdwZ.js');
var PriceV4 = require('./PriceV4-CAdVMHnO.js');
var components_Customise_CustomizeContext_types = require('./components/Customise/CustomizeContext/types.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const HALFCARD_HEIGHT = "90vh";
styled__default.default.div(({ theme, hideBorder }) => (Object.assign({ borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`, margin: `${theme.spacing.xxLarge} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}` }, (hideBorder && {
    borderBottom: "none",
    marginBottom: 0,
}))));
styled__default.default(Text.Text)(({ theme }) => ({
    marginBottom: theme.spacing.small,
    marginTop: theme.spacing.xxSmall,
}));
const Price = styled__default.default.span `
    & > *::before {
        content: "\\20B9";
        margin-right: 0.1rem;
    }
`;
const ContentContainer = styled__default.default.div(({ theme }) => {
    const windowHeight = typeof window !== "undefined" ? `${(window.innerHeight * 9) / 10}px` : HALFCARD_HEIGHT;
    return {
        padding: `0 ${theme.spacing.medium}`,
        overflowY: "auto",
        overflowX: "hidden",
        paddingBottom: theme.spacing.large,
        marginBottom: `calc(100px + ${HALFCARD_HEIGHT} - ${windowHeight})`,
    };
});
const StyledButton = styled__default.default(Button.Button) `
    text-align: center;
`;
const StyledButtonContainer = styled__default.default.div(() => ({
    width: "55%",
}));
const FooterContainer = styled__default.default.div(({ theme, showSelectionSummary }) => (Object.assign(Object.assign({ padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`, boxShadow: "0px -3px 20px 0px rgba(0, 0, 0, 0.08)", backgroundColor: theme.colors[theme.colorMode].background_Primary }, (showSelectionSummary && {
    borderTopLeftRadius: theme.spacing.medium,
    borderTopRightRadius: theme.spacing.medium,
})), { position: "fixed", bottom: 0, left: 0, right: 0 })));
const StepCutomizeFooter = styled__default.default.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const StepCustomizeContent = styled__default.default.div `
    display: flex;
    align-items: center;
`;
const StepCustomizeWrapper = styled__default.default.div(({ theme }) => ({
    marginBottom: theme.spacing.large,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "> button": {
        background: "none",
        border: "none",
        padding: "0",
        margin: "0",
        boxShadow: "none",
    },
}));
const Circle = styled__default.default.div(({ theme }) => ({
    width: "6px",
    height: "6px",
    backgroundColor: theme.colors[theme.colorMode].border_Secondary,
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    borderRadius: theme.cornerRadius.halfRounded,
    marginRight: theme.spacing.medium,
}));
const AddButtonWrapper = styled__default.default.div(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));
const GroupListContainer = styled__default.default(CardContainer.CardContainer)(({ theme }) => ({
    padding: `${theme.spacing.large} ${theme.spacing.medium} 0`,
}));
const GroupContainer = styled__default.default.div(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));
const GroupTitle = styled__default.default(Text.Text)(({ theme }) => ({
    display: "flex",
    padding: `${theme.spacing.xSmall} 0 ${theme.spacing.medium} 0`,
}));
const GroupInfo = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
}));
const GroupItemContainer = styled__default.default.div(({ theme, isDisabled }) => (Object.assign(Object.assign({ display: "flex", marginBottom: theme.spacing.large, justifyContent: "space-between" }, (isDisabled && {
    opacity: 0.5,
})), { ".custom-checkbox": {
        padding: 0,
        top: 0,
    } })));
const GroupItemContent = styled__default.default.div(() => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));
const GroupItemNameContainer = styled__default.default.div(() => ({
    display: "flex",
}));
const GroupItemIcon = styled__default.default.div(({ theme }) => ({
    marginRight: theme.spacing.small,
}));
const GroupItemName = styled__default.default.span(({ theme }) => ({
    marginRight: theme.spacing.small,
    flex: 1,
}));
const RadioWrapper = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
}));
const GroupItemPrice = styled__default.default.span(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
    display: "flex",
}));
const Divider = styled__default.default.div(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    margin: `${theme.spacing.medium} 0`,
}));
const CustomiseV1Container = styled__default.default.div(({ backgroundColor, theme }) => ({
    display: "flex",
    flexFlow: "column",
    height: "90vh",
    width: "100%",
    backgroundColor: backgroundColor
        ? backgroundColor[theme.colorMode]
        : theme.colors[theme.colorMode].background_Secondary,
}));
const CustomiseContainer = styled__default.default.div({
    display: "flex",
    flexFlow: "column",
    height: "100%",
});

const VariantItem$2 = (props) => {
    const { variant, checked } = props;
    const inStock = utils.getVariantInStock(variant);
    return (React__default.default.createElement(GroupItemContainer, { onClick: () => inStock && props.onChange(variant.id), isDisabled: !inStock },
        React__default.default.createElement(GroupItemContent, null,
            React__default.default.createElement(GroupItemIcon, null,
                React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: variant.isVeg === 1 ? "vegVeg16" : "nonvegNonVeg16" })),
            React__default.default.createElement(GroupItemName, null,
                React__default.default.createElement(Text.Text, { color: "text_High_Emphasis", variant: "V2.body1.neutral.regular" }, variant.name)),
            (variant === null || variant === void 0 ? void 0 : variant.price) && variant.price > 0 && (React__default.default.createElement(GroupItemPrice, null,
                React__default.default.createElement(Price, null,
                    React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, variant.price / 100))))),
        React__default.default.createElement(RadioWrapper, null,
            React__default.default.createElement(RadioGroup.Radio, { id: variant.id, orientation: "ltr", checked: checked, label: "", value: "" }))));
};
var VariantItem$3 = React__default.default.memo(VariantItem$2);

const VariantGroup$2 = (props) => {
    const { selectedVariation, variantGroup, showToast, groupIndex } = props;
    const { dispatch, state } = React.useContext(CustomizeContext.CustomizeContext);
    const onChange = (variationId) => {
        const variations = jsUtils.getNestedValue(props, "variantGroup.variations", []);
        const variant = variations.find((v) => v.id == variationId);
        if (!variant || (variant && variant.inStock !== 1))
            return;
        props
            .onChange(groupIndex, variationId)(dispatch, () => ({ customize: state }))
            .catch((reason) => {
            showToast(reason);
        });
    };
    return (React__default.default.createElement(GroupContainer, null,
        React__default.default.createElement(GroupTitle, { id: props.variantGroup.name, color: "text_High_Emphasis", variant: "V2.body1.neutral.bold", "aria-label": jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.SELECT_VARIANT_GROUP, variantGroup.name) }, props.variantGroup.name),
        React__default.default.createElement(GroupListContainer, { cornerRadius: "medium", customElevation: "skim", elevation: true }, props.variantGroup.variations &&
            props.variantGroup.variations.map((variant) => (React__default.default.createElement(VariantItem$3, { key: variant.id, variant: variant, checked: selectedVariation.id === variant.id, onChange: onChange }))))));
};
var VariantGroup$3 = React__default.default.memo(VariantGroup$2);

const AddonItem = (props) => {
    const { addon, checked, choiceIndex, onAddonSelect } = props;
    const inStock = utils.getAddonInStock(addon);
    const name = utils.getAddonName(addon);
    const price = utils.getAddonPrice(addon);
    const getSlug = utils.replaceAllOccurence(/\s|\(|\)|\./g, "_", name);
    const ariaLabel = utils.getAddonItemV2Label({ name, addon, price, inStock });
    return (React__default.default.createElement(GroupItemContainer, { onClick: () => inStock && onAddonSelect(name, choiceIndex), isDisabled: !inStock },
        React__default.default.createElement(GroupItemContent, null,
            React__default.default.createElement(GroupItemNameContainer, null,
                React__default.default.createElement(GroupItemIcon, null,
                    React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: addon.isVeg === 1 ? "vegVeg16" : "nonvegNonVeg16" })),
                React__default.default.createElement(GroupItemName, null,
                    React__default.default.createElement(Text.Text, { color: "text_High_Emphasis", variant: "V2.body1.neutral.regular" }, name))),
            +price > 0 && (React__default.default.createElement(GroupItemPrice, null,
                React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, "+\u00A0"),
                React__default.default.createElement(Price, null,
                    React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body1.neutral.regular" }, price))))),
        React__default.default.createElement(Checkbox.Checkbox, { checked: checked, id: String(choiceIndex), "aria-label": ariaLabel, orientation: "rtl", "data-testid": `add-item-checkbox-${getSlug}`, label: "" })));
};
var AddonItem$1 = React__default.default.memo(AddonItem);

const AddonGroup$2 = (props) => {
    const { addonGroup, showToast, selectedAddons } = props;
    const { dispatch, state } = React.useContext(CustomizeContext.CustomizeContext);
    const minAddons = utils.getMinAddons(addonGroup);
    const maxAddons = utils.getMaxAddons(addonGroup);
    const isAddonChecked = (choiceIndex) => {
        return (selectedAddons[props.groupIndex] !== undefined &&
            selectedAddons[props.groupIndex][choiceIndex] === true);
    };
    const toggleAddon = (_, choiceIndex) => {
        const choices = utils.getChoices(addonGroup);
        if (choices && !utils.getAddonInStock(choices[choiceIndex])) {
            return;
        }
        props
            .onAddonSelect(props.groupIndex, choiceIndex)(dispatch, () => ({
            customize: state,
        }))
            .catch((reason) => {
            showToast(reason);
        });
    };
    const renderItem = (item, index) => {
        return (React__default.default.createElement(AddonItem$1, { addon: item, key: index, choiceIndex: index, checked: isAddonChecked(index), onAddonSelect: toggleAddon }));
    };
    const getSelectedNumberOfAddons = () => {
        return jsUtils.isEmpty(selectedAddons[props.groupIndex])
            ? 0
            : Object.keys(selectedAddons[props.groupIndex]).length;
    };
    const renderGroupInfo = () => {
        const displaySelected = Math.min(getSelectedNumberOfAddons(), maxAddons || 0);
        if (maxAddons && maxAddons > 0) {
            return (React__default.default.createElement(Text.Text, { variant: "V2.body1.neutral.regular", color: "text_Med_Emphasis" },
                "(",
                `${displaySelected}/${maxAddons}`,
                ")"));
        }
        else if (!maxAddons || maxAddons < 0) {
            return (React__default.default.createElement(Text.Text, { variant: "V2.body1.neutral.regular", color: "text_Med_Emphasis" },
                " ",
                "(",
                components_Customise_constants_index.TEXTS.OPTIONAL,
                ")"));
        }
        return null;
    };
    const choices = utils.getChoices(addonGroup);
    return (React__default.default.createElement(GroupContainer, null,
        React__default.default.createElement(GroupTitle, { color: "text_High_Emphasis", variant: "V2.body1.neutral.bold", "aria-hidden": true },
            utils.getGroupName(addonGroup),
            React__default.default.createElement(GroupInfo, null, renderGroupInfo())),
        React__default.default.createElement(ScreenReaderOnly.ScreenReaderOnly, { as: "p", tabIndex: 0, role: "heading", id: utils.getGroupName(addonGroup), text: utils.getAddonGroupV1Label(getSelectedNumberOfAddons(), utils.getGroupName(addonGroup), minAddons) }),
        React__default.default.createElement(GroupListContainer, { cornerRadius: "medium", customElevation: "skim", elevation: true },
            React__default.default.createElement(PartialList.PartialList, { renderRow: renderItem, visibleRows: components_Customise_constants_index.VISIBLE_ITEMS_COUNT, adjustRowCount: 0, data: choices }))));
};
var AddonGroup$3 = React__default.default.memo(AddonGroup$2);

const CustomizeContentV1 = (props) => {
    const variantGroups = props.validVariants;
    const addonGroups = props.validAddons;
    const { showToast } = props;
    return (React__default.default.createElement(ContentContainer, null, variantGroups === null || variantGroups === void 0 ? void 0 :
        variantGroups.map((group, index) => {
            return (React__default.default.createElement(VariantGroup$3, { key: index, variantGroup: group, onChange: props.updateVariant, groupIndex: index, selectedVariation: props.selectedVariants[index], showToast: showToast }));
        }),
        addonGroups.map((group, index) => {
            return (React__default.default.createElement(AddonGroup$3, { key: index, groupIndex: index, addonGroup: group, onAddonSelect: props.toggleAddon, selectedAddons: props.selectedAddons, showToast: showToast }));
        })));
};
var ContentV4$1 = React__default.default.memo(CustomizeContentV1);

const Container = styled__default.default.div(({ theme }) => ({
    marginBottom: theme.spacing.medium,
    padding: `${theme.spacing.xSmall} 0 ${theme.spacing.medium} 0`,
    borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
}));
const CustomiseDetailsButton = styled__default.default.button({
    all: "unset",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: "inherit",
});

const SelectionSummary = (props) => {
    const { selectedAddons, selectedVariants } = props;
    const getSelectionText = () => {
        let selectionText = "";
        let fullSelectionText = "";
        if (!jsUtils.isEmpty(selectedVariants)) {
            selectedVariants.forEach((v, index) => {
                selectionText += `${v.group_name}: ${v.name}`;
                if (index < selectedVariants.length - 1)
                    selectionText += ", ";
            });
        }
        if (!jsUtils.isEmpty(selectedVariants) && !jsUtils.isEmpty(selectedAddons))
            selectionText += ", ";
        if (!jsUtils.isEmpty(selectedAddons)) {
            selectedAddons.forEach((a, index) => {
                selectionText += `${a.name}`;
                if (index < selectedAddons.length - 1)
                    selectionText += ", ";
            });
        }
        fullSelectionText = selectionText;
        selectionText = selectionText.split(",").join("  •  ");
        return { selectionText, fullSelectionText };
    };
    if (jsUtils.isEmpty(props.selectedAddons) && jsUtils.isEmpty(props.selectedVariants))
        return null;
    const selectionText = getSelectionText().selectionText;
    const fullSelectionText = getSelectionText().fullSelectionText;
    const SELECTION_ITEM_LABEL = "You have selected the following customization: {0}";
    return (React__default.default.createElement(Container, { "data-testid": "selection-summary-container" },
        React__default.default.createElement(ScreenReaderOnly.ScreenReaderOnly, { as: "p", tabIndex: 0, text: jsUtils.format(SELECTION_ITEM_LABEL, fullSelectionText) }),
        React__default.default.createElement(Text.Text, { "aria-hidden": true, variant: "V2.body2.neutral.regular", color: "text_Med_Emphasis", "data-testid": "selection-summ-text" }, selectionText)));
};
var SelectionSummary$1 = React__default.default.memo(SelectionSummary);

const CustomizeAddButton = (props) => {
    const [inProgress, setInProgress] = React.useState(false);
    const getPrice = () => {
        const { validAddons, selectedAddons, selectedVariants, itemData } = props;
        return utils.getV1Prices(validAddons, selectedAddons, selectedVariants, itemData);
    };
    const getAction = (updatingExistingCustomization) => {
        return updatingExistingCustomization ? props.updateCustomizeItem : props.addCustomizeItem;
    };
    const addItemToCart = (selectedAddons = [], selectedVariants = []) => {
        const { itemData, updatingExistingCustomization } = props;
        const menuItemId = utils.getItemId(itemData);
        const newItem = {
            menu_item_id: menuItemId,
            menu_item_uuid: utils.generateUUID(menuItemId, selectedAddons, selectedVariants),
            addons: selectedAddons,
            variants: selectedVariants,
            quantity: 1,
        };
        const action = getAction(updatingExistingCustomization);
        return action(newItem);
    };
    const successHandler = () => {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.closeCustomize) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const failureHandler = (error) => {
        const message = typeof error === "object" && error.message ? error.message : components_Customise_constants_index.ERROR_MESSAGES.OTHER;
        props.showToast(message);
    };
    const addCustomization = () => {
        if (inProgress)
            return;
        const { itemData, validAddons, selectedAddons, selectedVariants } = props;
        setInProgress(true);
        utils.getSelectedAddonsVariants(itemData, validAddons, selectedAddons, selectedVariants)
            .then((result) => addItemToCart(result.selectedAddonList, result.selectedVariantList))
            .then((success) => (success ? successHandler() : failureHandler()))
            .catch(failureHandler)
            .then(() => setInProgress(false));
    };
    const getPriceProps = () => {
        const getPriceValue = getPrice();
        const price = props.price || getPriceValue.price;
        const finalPrice = props.finalPrice || getPriceValue.finalPrice;
        if (finalPrice)
            return { price, finalPrice };
        return { price };
    };
    const getPriceValue = getPrice();
    const priceProps = getPriceProps();
    const addOns = !jsUtils.isEmpty(props.selectedAddons) || !jsUtils.isEmpty(props.selectedVariants);
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement("div", null,
            React__default.default.createElement(PriceV4.PriceV4, Object.assign({}, priceProps, { divideByHundred: false, variant: "secondary", customColor: "text_Highest_Emphasis", customVariant: "V2.body1.neutral.medium" })),
            addOns && (React__default.default.createElement(CustomiseDetailsButton, { onClick: props === null || props === void 0 ? void 0 : props.toggleSelectionSummary },
                React__default.default.createElement(Text.Text, { color: "primary", variant: "V2.body3.neutral.bold" },
                    props.showSelectionSummary ? components_Customise_constants_index.TEXTS.HIDE : components_Customise_constants_index.TEXTS.VIEW,
                    components_Customise_constants_index.TEXTS.CUSTOMIZED_ITEM)))),
        React__default.default.createElement(StyledButtonContainer, null,
            React__default.default.createElement(StyledButton, { variant: "positive", onClick: addCustomization, isDisabled: inProgress, "data-cy": "customize-footer-add-button", "aria-label": utils.getAddButtonLabel(getPriceValue, props.updatingExistingCustomization, props.price) }, props.updatingExistingCustomization ? components_Customise_constants_index.TEXTS.UPDATE_ITEM : components_Customise_constants_index.TEXTS.ADD_ITEM))));
};
var CustomizeAddButton$1 = React__default.default.memo(CustomizeAddButton);

const CustomizeFooter$1 = (props) => {
    const [showSelectionSummary, setShowSelectionSummary] = React.useState(false);
    const { state: { item, validAddons, selectedAddons, selectedVariants, updatingExistingCustomization, }, } = React.useContext(CustomizeContext.CustomizeContext);
    const toggleSelectionSummary = () => {
        setShowSelectionSummary((prev) => !prev);
    };
    return (React__default.default.createElement(FooterContainer, { showSelectionSummary: showSelectionSummary && (!jsUtils.isEmpty(selectedAddons) || !jsUtils.isEmpty(selectedVariants)) },
        showSelectionSummary && (React__default.default.createElement(SelectionSummary$1, { selectedAddons: utils.getSelectedAddons(item, selectedAddons), selectedVariants: utils.getSelectedVariants(item, selectedVariants) })),
        React__default.default.createElement(AddButtonWrapper, null,
            React__default.default.createElement(CustomizeAddButton$1, { closeCustomize: props.closeCustomize, showSelectionSummary: showSelectionSummary, toggleSelectionSummary: toggleSelectionSummary, canGoBack: false, itemData: item, validAddons: validAddons, selectedAddons: selectedAddons, selectedVariants: selectedVariants, updatingExistingCustomization: updatingExistingCustomization, showToast: props.showToast, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem }))));
};
var Footer$1 = React__default.default.memo(CustomizeFooter$1);

const showCustomizeModal = (data, updatingExistingCustomization = false, useUx3Flow = false) => ({
    type: components_Customise_CustomizeContext_types.SHOW_CUSTOMIZE_MODAL,
    payload: Object.assign(Object.assign({ item: data }, _getDefaults(data)), { updatingExistingCustomization,
        useUx3Flow }),
});
const updateVariant = (groupIndex, variationId) => {
    return (dispatch, getState) => {
        const state = getState();
        const version = utils.getVersion(jsUtils.getNestedValue(state, "customize.item"));
        return version == components_Customise_constants_index.CUSTOMIZE_VERSIONS.V2
            ? _updateVariantV2(dispatch, getState, groupIndex, variationId)
            : _updateVariantV1(dispatch, getState, groupIndex, variationId);
    };
};
const moveToNextStep = () => ({
    type: components_Customise_CustomizeContext_types.NEXT_STEP,
});
const changeStep = (step) => ({
    type: components_Customise_CustomizeContext_types.CHANGE_STEP,
    payload: { currentStep: step },
});
const toggleAddon = (groupIndex, choiceIndex) => {
    return (dispatch, getState) => {
        const state = getState();
        const { customize: { selectedAddons, validAddons }, } = state;
        const newSelectedAddons = Object.assign({}, selectedAddons);
        if (!jsUtils.isEmpty(newSelectedAddons[groupIndex]) &&
            !jsUtils.isEmpty(newSelectedAddons[groupIndex][choiceIndex])) {
            const choice = Object.assign({}, newSelectedAddons[groupIndex]);
            delete choice[choiceIndex];
            if (jsUtils.isEmpty(choice)) {
                delete newSelectedAddons[groupIndex];
            }
            else {
                newSelectedAddons[groupIndex] = choice;
            }
            dispatch({
                type: components_Customise_CustomizeContext_types.TOGGLE_ADDON,
                payload: { selectedAddons: newSelectedAddons },
            });
            return Promise.resolve();
        }
        else {
            const addonGroup = utils.getAddonGroup(validAddons, groupIndex);
            return utils.checkMaxAddonsAddons(addonGroup, newSelectedAddons[groupIndex])
                .then(() => {
                if (jsUtils.isEmpty(newSelectedAddons[groupIndex])) {
                    newSelectedAddons[groupIndex] = {};
                }
                newSelectedAddons[groupIndex][choiceIndex] = true;
                dispatch({
                    type: components_Customise_CustomizeContext_types.TOGGLE_ADDON,
                    payload: { selectedAddons: newSelectedAddons },
                });
                return Promise.resolve();
            })
                .catch((reason) => {
                return Promise.reject(reason);
            });
        }
    };
};
const _getDefaults = (item) => {
    const version = utils.getVersion(item);
    return version === components_Customise_constants_index.CUSTOMIZE_VERSIONS.V2 ? _getDefaultsV2(item) : _getDefaultsV1(item);
};
const _getDefaultsV1 = (item) => {
    return {
        selectedAddons: _getDefaultAddonsV1(item),
        selectedVariants: _getDefaultVariantsV1(item),
        validAddons: _getValidAddonsV1(item),
        validVariants: _getValidVariantsV1(item),
        version: utils.getVersion(item),
    };
};
const _getValidAddonsV1 = (item) => {
    return utils.getAddons(item);
};
const _getValidVariantsV1 = (item) => {
    return utils.getVariants(item);
};
const _getDefaultVariantsV1 = (item) => {
    const variantGroups = utils.getVariants(item);
    const selectedVariants = {};
    if (jsUtils.isEmpty(variantGroups))
        return {};
    variantGroups.forEach((group, gIndex) => {
        var _a;
        (_a = group === null || group === void 0 ? void 0 : group.variations) === null || _a === void 0 ? void 0 : _a.forEach((variation) => {
            if (variation.default == 1) {
                selectedVariants[gIndex] = variation;
                return;
            }
        });
    });
    return selectedVariants;
};
const _getDefaultAddonsV1 = (item) => {
    const selectedAddons = {};
    const validAddons = utils.getAddons(item);
    if (!validAddons.length)
        return {};
    validAddons.forEach((group, groupIndex) => {
        if (jsUtils.isEmpty(group.choices)) {
            return;
        }
        group.choices.forEach((choice, choiceIndex) => {
            const entry = validAddons.find((a) => (a.choice_id || a.choiceId) == choice.id &&
                (a.group_id || a.groupId) == (group.group_id || group.groupId));
            if (!jsUtils.isEmpty(entry)) {
                selectedAddons[groupIndex] = selectedAddons[groupIndex]
                    ? selectedAddons[groupIndex]
                    : {};
                selectedAddons[groupIndex][choiceIndex] = true;
            }
        });
    });
    return selectedAddons;
};
const _getTotalSteps = (pricingModelKey, _pricingModelHash) => {
    return pricingModelKey.split("+").length;
};
const _getDefaultsV2 = (item) => {
    const addons = utils.getAddons(item);
    const variantsV2 = utils.getVariants(item);
    const pricingModels = utils.getPricingModels(item);
    const variantsHash = _getVariantsHash(variantsV2);
    const pricingModelHash = _getPricingModelHash(pricingModels);
    const addonsHash = _getAddonsHash(addons);
    const pricingModelKey = _getPricingModelKey(variantsV2, variantsHash);
    const validAddons = _getValidAddons(addons, pricingModelKey, pricingModelHash);
    return {
        selectedAddons: _getSelectedAddons(item.addons, validAddons),
        selectedVariants: _getSelectedVariants(pricingModelKey, variantsHash),
        variantsV2: {
            pricingModelHash,
            variantsHash,
            addonsHash,
        },
        pricingModelKey,
        validVariants: _getValidVariants(variantsV2, pricingModelKey, pricingModelHash),
        validAddons: validAddons,
        currentStep: 1,
        totalSteps: _getTotalSteps(pricingModelKey),
        version: utils.getVersion(item),
    };
};
const _getSelectedAddons = (addedAddons, validAddons) => {
    if (jsUtils.isEmpty(addedAddons))
        return {};
    const selectedAddons = {};
    if (!jsUtils.isEmpty(validAddons)) {
        validAddons.forEach((group, groupIndex) => {
            if (!jsUtils.isEmpty(group.choices)) {
                group.choices.forEach((choice, choiceIndex) => {
                    const addonFound = addedAddons.find((a) => (a.choice_id || a.choiceId) == choice.id &&
                        (a.group_id || a.groupId) == (group.group_id || group.groupId));
                    if (!jsUtils.isEmpty(addonFound)) {
                        if (jsUtils.isEmpty(selectedAddons[groupIndex]))
                            selectedAddons[groupIndex] = {};
                        selectedAddons[groupIndex][choiceIndex] = true;
                    }
                });
            }
        });
    }
    return selectedAddons;
};
const _getAddonsHash = (addons) => {
    const addonsHash = {};
    addons.forEach((group) => {
        const id = group.group_id || group.groupId;
        if (id) {
            addonsHash[id] = {
                name: group.group_name || group.groupName || "",
                choices: {},
            };
        }
        if (jsUtils.isEmpty(group.choices)) {
            return;
        }
        group.choices.forEach((choice) => {
            choice.group_id = group.group_id || group.groupId;
            choice.groupId = choice.group_id;
            if (id) {
                addonsHash[id].choices[choice.id] = choice;
            }
        });
    });
    return addonsHash;
};
const _getVariantsHash = (variantsV2) => {
    const variantsHash = {};
    variantsV2.forEach((group) => {
        var _a;
        (_a = group === null || group === void 0 ? void 0 : group.variations) === null || _a === void 0 ? void 0 : _a.forEach((variation) => {
            const obj = {
                group_name: group.name,
                groupName: group.name,
                value: variation,
            };
            variantsHash[(group.group_id || group.groupId) + "&" + variation.id] = obj;
        });
    });
    return variantsHash;
};
const _getPricingModelHash = (pricingModels) => {
    const pricingModelHash = {};
    pricingModels.forEach((model) => {
        let key = "";
        if (model.variations) {
            model.variations.forEach((v) => {
                key +=
                    (key ? "+" : "") +
                        (v.group_id || v.groupId) +
                        "&" +
                        (v.variation_id || v.variationId);
            });
        }
        pricingModelHash[key] = model;
    });
    return pricingModelHash;
};
const _getStartPoint = (variantsV2) => {
    let start = "";
    const variations = variantsV2[0] ? variantsV2[0].variations : [];
    variations === null || variations === void 0 ? void 0 : variations.forEach((v) => {
        if (!start && v.default) {
            start = (variantsV2[0].group_id || variantsV2[0].groupId) + "&" + v.id;
            return false;
        }
    });
    return start;
};
const _getPricingModelKey = (variantsV2, variantsHash, start) => {
    var _a, _b, _c, _d;
    let key = "";
    start = !start ? _getStartPoint(variantsV2) : start;
    key += start;
    let variant = variantsHash[start] ? variantsHash[start].value : undefined;
    if (!variant || (!variant.default_dependent_variant && !variant.dependantVariation))
        return key;
    let next = (variant.default_dependent_variant
        ? variant.default_dependent_variant.group_id
        : (_a = variant === null || variant === void 0 ? void 0 : variant.dependantVariation) === null || _a === void 0 ? void 0 : _a.groupId) +
        "&" +
        (variant.default_dependent_variant
            ? variant.default_dependent_variant.variation_id
            : (_b = variant === null || variant === void 0 ? void 0 : variant.dependantVariation) === null || _b === void 0 ? void 0 : _b.variationId);
    while (next) {
        key += "+" + next;
        variant = variantsHash[next] ? variantsHash[next].value : undefined;
        next =
            (variant === null || variant === void 0 ? void 0 : variant.default_dependent_variant) || (variant === null || variant === void 0 ? void 0 : variant.dependantVariation)
                ? (variant.default_dependent_variant
                    ? variant.default_dependent_variant.group_id
                    : (_c = variant === null || variant === void 0 ? void 0 : variant.dependantVariation) === null || _c === void 0 ? void 0 : _c.groupId) +
                    "&" +
                    (variant.default_dependent_variant
                        ? variant.default_dependent_variant.variation_id
                        : (_d = variant === null || variant === void 0 ? void 0 : variant.dependantVariation) === null || _d === void 0 ? void 0 : _d.variationId)
                : "";
    }
    return key;
};
const _getValidVariants = (variantsV2, pricingModelKey, pricingModelHash) => {
    const validVariants = variantsV2;
    const variantsKeys = pricingModelKey.split("+");
    let searchKey = "";
    variantsKeys.forEach((key, index) => {
        var _a;
        searchKey += (searchKey ? "+" : "") + key;
        if (index == 0) {
            const grpId = key ? key.split("&")[0] : "", grp = validVariants.find((v) => v.group_id == grpId || v.groupId == grpId);
            if (grp && grp.variations)
                grp.variations.forEach((v) => (v.show = true));
        }
        if (index == variantsKeys.length - 1)
            return false;
        let filteredKeys = [];
        Object.keys(pricingModelHash).forEach((modelKey) => {
            if (modelKey.indexOf(searchKey) === 0) {
                let temp = modelKey.replace(`${searchKey}+`, "");
                temp = temp.split("+");
                filteredKeys.push(temp[0]);
            }
        });
        const _onlyUnique = (value, idx, self) => {
            return self.indexOf(value) === idx;
        };
        const unique = (array = []) => array.filter(_onlyUnique);
        filteredKeys = unique(filteredKeys);
        if (!filteredKeys.length)
            return;
        const grpId = filteredKeys[0].split("&")[0], grp = validVariants.find((v) => v.group_id == grpId || v.groupId == grpId);
        (_a = grp === null || grp === void 0 ? void 0 : grp.variations) === null || _a === void 0 ? void 0 : _a.forEach((v) => (v.show = false));
        filteredKeys.forEach((k) => {
            var _a;
            const temp = k.split("&");
            const variation = (_a = grp === null || grp === void 0 ? void 0 : grp.variations) === null || _a === void 0 ? void 0 : _a.find((v) => v.id == temp[1]);
            if (variation) {
                variation.show = true;
            }
        });
    });
    return validVariants;
};
const _getValidAddons = (addons, pricingModelKey, pricingModelHash) => {
    const addonCombinations = jsUtils.getNestedValue(pricingModelHash[pricingModelKey], "addon_combinations") ||
        jsUtils.getNestedValue(pricingModelHash[pricingModelKey], "addonCombinations");
    const validAddons = [];
    if (jsUtils.isEmpty(addonCombinations))
        return validAddons;
    if (!jsUtils.isEmpty(addons)) {
        addons.forEach((group) => {
            const newGroup = Object.assign(Object.assign({}, group), { choices: [] });
            if (!jsUtils.isEmpty(group.choices)) {
                group.choices.forEach((choice) => {
                    var _a;
                    const ac = addonCombinations.find((ac_item) => (String(ac_item.addon_id) == String(choice.id) &&
                        String(ac_item.group_id) == String(group.group_id)) ||
                        (ac_item.addonId == choice.id && ac_item.groupId == group.groupId));
                    if (!jsUtils.isEmpty(ac))
                        (_a = newGroup === null || newGroup === void 0 ? void 0 : newGroup.choices) === null || _a === void 0 ? void 0 : _a.push(choice);
                });
            }
            if (!jsUtils.isEmpty(newGroup.choices))
                validAddons.push(newGroup);
        });
    }
    return validAddons;
};
const _getSelectedVariants = (pricingModelKey, variantsHash) => {
    const variants = pricingModelKey.split("+");
    const selectedVariants = {};
    variants.forEach((v, index) => {
        selectedVariants[index] = variantsHash[v].value;
    });
    return selectedVariants;
};
const _updateVariantV2 = (dispatch, getState, groupIndex, variationId) => {
    var _a, _b;
    const { customize: { item, pricingModelKey, validVariants, variantsV2 }, } = getState();
    const variation = (_b = (_a = validVariants[groupIndex]) === null || _a === void 0 ? void 0 : _a.variations) === null || _b === void 0 ? void 0 : _b.find((v) => v.id == variationId);
    const temp = pricingModelKey.split("+");
    let start = temp[0];
    if (groupIndex && variation) {
        const parentVariant = variantsV2.variantsHash[temp[groupIndex - 1]];
        if (parentVariant.value) {
            if (parentVariant.value.default_dependent_variant) {
                parentVariant.value.default_dependent_variant.variation_id = variation.id;
            }
            if (parentVariant.value.dependantVariation) {
                parentVariant.value.dependantVariation.variationId = variation.id;
            }
        }
    }
    else if (variation) {
        start = temp[0].split("&")[0] + "&" + variation.id;
    }
    const newPricingModelKey = _getPricingModelKey(variantsV2, variantsV2.variantsHash, start);
    if (pricingModelKey == newPricingModelKey)
        return Promise.resolve();
    const variantGroups = utils.getVariants(item);
    const addons = utils.getAddons(item);
    dispatch({
        type: components_Customise_CustomizeContext_types.UPDATE_VARIANT,
        payload: {
            validAddons: _getValidAddons(addons, newPricingModelKey, variantsV2.pricingModelHash),
            validVariants: _getValidVariants(variantGroups, newPricingModelKey, variantsV2.pricingModelHash),
            pricingModelKey: newPricingModelKey,
            selectedVariants: _getSelectedVariants(newPricingModelKey, variantsV2.variantsHash),
        },
    });
    return Promise.resolve();
};
const _updateVariantV1 = (dispatch, getState, groupIndex, variationId) => {
    var _a, _b;
    const state = getState();
    const { customize: { selectedVariants, item }, } = state;
    const variantGroups = utils.getVariants(item);
    const newVariation = (_b = (_a = variantGroups[groupIndex]) === null || _a === void 0 ? void 0 : _a.variations) === null || _b === void 0 ? void 0 : _b.find((v) => v.id == variationId);
    const newSelectedVariants = Object.assign({}, selectedVariants);
    if (newVariation) {
        newSelectedVariants[groupIndex] = newVariation;
    }
    dispatch({
        type: components_Customise_CustomizeContext_types.UPDATE_VARIANT,
        payload: {
            selectedVariants: newSelectedVariants,
        },
    });
    return Promise.resolve();
};

const CustomizeV1 = (props) => {
    const { closeCustomize, currentStep, showToast, addCustomizeItem, updateCustomizeItem } = props;
    const { state: { validAddons, validVariants, selectedAddons, selectedVariants, item }, } = React.useContext(CustomizeContext.CustomizeContext);
    return (React__default.default.createElement(CustomiseV1Container, { backgroundColor: props.backgroundColor },
        React__default.default.createElement(CustomiseContainer, null,
            React__default.default.createElement(Header.Header, { itemData: item, currentStep: currentStep }),
            React__default.default.createElement(ContentV4$1, { validAddons: validAddons, validVariants: validVariants, selectedAddons: selectedAddons, selectedVariants: selectedVariants, updateVariant: updateVariant, toggleAddon: toggleAddon, showToast: showToast }),
            React__default.default.createElement(Footer$1, { closeCustomize: closeCustomize, showToast: showToast, addCustomizeItem: addCustomizeItem, updateCustomizeItem: updateCustomizeItem }))));
};
var CustomizeV1$1 = React__default.default.memo(CustomizeV1);

const VariantItem = (props) => {
    const { pricingModelHash, pricingModelKey, variant, itemData, checked, showPrice } = props;
    const getPrice = () => {
        return utils.getV2VariantPrice(pricingModelHash, pricingModelKey, variant, itemData);
    };
    const inStock = utils.getVariantInStock(variant);
    const priceProps = getPrice();
    const price = showPrice ? priceProps.price : undefined;
    const ariaLabel = utils.getVariantItemV2Label({ variant, price, inStock });
    return (React__default.default.createElement(GroupItemContainer, { onClick: () => inStock && props.onChange(variant.id), isDisabled: !inStock },
        React__default.default.createElement(GroupItemContent, null,
            React__default.default.createElement(GroupItemNameContainer, null,
                React__default.default.createElement(GroupItemIcon, null,
                    React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: variant.isVeg === 1 ? "vegVeg16" : "nonvegNonVeg16" })),
                React__default.default.createElement(GroupItemName, null,
                    React__default.default.createElement(Text.Text, { color: "text_High_Emphasis", variant: "V2.body1.neutral.regular" }, variant.name))),
            showPrice && React__default.default.createElement(PriceV4.PriceV4, Object.assign({}, priceProps, { divideByHundred: false }))),
        React__default.default.createElement(RadioWrapper, null,
            React__default.default.createElement(RadioGroup.Radio, { id: variant.id, "aria-label": ariaLabel, orientation: "ltr", checked: checked, "data-testid": `menu-variant-item-${variant.name}`, label: "", value: "" }))));
};
var VariantItem$1 = React__default.default.memo(VariantItem);

const VariantGroup = (props) => {
    const { state, dispatch } = React.useContext(CustomizeContext.CustomizeContext);
    const onChange = (variationId) => {
        const variations = jsUtils.getNestedValue(props, "variantGroup.variations", []);
        const variant = variations.find((v) => v.id == variationId);
        if (!variant || variant.inStock !== 1)
            return;
        const { showToast } = props;
        props
            .onChange(props.groupIndex, variationId)(dispatch, () => ({
            customize: state,
        }))
            .catch((reason) => {
            showToast(reason);
        });
    };
    const getVariations = (group) => {
        var _a;
        return (_a = group === null || group === void 0 ? void 0 : group.variations) === null || _a === void 0 ? void 0 : _a.filter((v) => v === null || v === void 0 ? void 0 : v.show);
    };
    const { selectedVariation, variantGroup, showPrice, pricingModelHash, pricingModelKey, itemData, } = props;
    const variations = getVariations(variantGroup);
    return (React__default.default.createElement(GroupContainer, null,
        React__default.default.createElement(GroupTitle, { id: props.variantGroup.name, color: "text_High_Emphasis", variant: "V2.body1.neutral.bold" }, props.variantGroup.name),
        React__default.default.createElement(GroupListContainer, { cornerRadius: "medium", customElevation: "skim", elevation: true }, variations === null || variations === void 0 ? void 0 : variations.map((variant) => (React__default.default.createElement(VariantItem$1, { key: variant.id, variant: variant, checked: selectedVariation.id === variant.id, onChange: onChange, showPrice: showPrice, pricingModelHash: pricingModelHash, pricingModelKey: pricingModelKey, itemData: itemData }))))));
};
var VariantGroup$1 = React__default.default.memo(VariantGroup);

const AddonGroup = (props) => {
    const { dispatch, state } = React.useContext(CustomizeContext.CustomizeContext);
    const groupIndex = props.groupIndex;
    const maxAddons = utils.getMaxAddons(props.addonGroup);
    const getGroupName = (group) => {
        return group.name || group.group_name || group.groupName;
    };
    const isAddonChecked = (choiceIndex) => {
        const { selectedAddons } = props;
        return (selectedAddons[groupIndex] !== undefined &&
            selectedAddons[groupIndex][choiceIndex] === true);
    };
    const getChoices = (group) => {
        return group.choices || [];
    };
    const toggleAddon = (addonName, choiceIndex) => {
        const { showToast, addonGroup } = props;
        const choices = getChoices(addonGroup);
        if (!utils.getAddonInStock(choices === null || choices === void 0 ? void 0 : choices[choiceIndex])) {
            return;
        }
        props
            .onAddonSelect(groupIndex, choiceIndex)(dispatch, () => ({ customize: state }))
            .catch((reason) => {
            showToast(reason);
        });
    };
    const renderItem = (addon, index) => {
        return (React__default.default.createElement(AddonItem$1, { addon: addon, key: index, choiceIndex: index, checked: isAddonChecked(index), onAddonSelect: toggleAddon }));
    };
    const getSelectedNumberOfAddons = () => {
        const { selectedAddons } = props;
        return jsUtils.isEmpty(selectedAddons[groupIndex])
            ? 0
            : Object.keys(selectedAddons[groupIndex]).length;
    };
    const renderGroupInfo = () => {
        const displaySelected = Math.min(getSelectedNumberOfAddons(), maxAddons || 0);
        if (maxAddons && maxAddons > 1) {
            return (React__default.default.createElement(Text.Text, { variant: "V2.body1.neutral.regular", color: "text_Med_Emphasis" },
                "(",
                `${displaySelected}/${maxAddons}`,
                ")"));
        }
        else if (!maxAddons || maxAddons < 0) {
            return (React__default.default.createElement(Text.Text, { variant: "V2.body1.neutral.regular", color: "text_Med_Emphasis" },
                " ",
                "(",
                components_Customise_constants_index.TEXTS.OPTIONAL,
                ")"));
        }
        return null;
    };
    const { addonGroup } = props;
    const choices = getChoices(addonGroup);
    const groupName = getGroupName(addonGroup);
    return (React__default.default.createElement(GroupContainer, null,
        React__default.default.createElement(GroupTitle, { color: "text_High_Emphasis", variant: "V2.body1.neutral.bold", "aria-hidden": true },
            getGroupName(addonGroup),
            React__default.default.createElement(GroupInfo, null, renderGroupInfo())),
        React__default.default.createElement(ScreenReaderOnly.ScreenReaderOnly, { as: "p", tabIndex: 0, role: "heading", id: groupName, text: groupName || "" }),
        React__default.default.createElement(GroupListContainer, { cornerRadius: "medium", customElevation: "skim", elevation: true },
            React__default.default.createElement(PartialList.PartialList, { renderRow: renderItem, visibleRows: components_Customise_constants_index.VISIBLE_ITEMS_COUNT, data: choices }))));
};
var AddonGroup$1 = React__default.default.memo(AddonGroup);

const PrevStepInfo = (props) => {
    const { currentStep, variantGroups, selectedVariants } = props;
    const { dispatch } = React.useContext(CustomizeContext.CustomizeContext);
    const onChangeLinkClick = () => {
        dispatch(props.changeStep(props.currentStep - 1));
    };
    if (currentStep < 2 ||
        variantGroups[currentStep - 2] === undefined ||
        selectedVariants[currentStep - 2] === undefined) {
        return null;
    }
    const groupName = variantGroups[currentStep - 2].name;
    const selectedVariantName = selectedVariants[currentStep - 2].name;
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(GroupListContainer, { cornerRadius: "medium", "data-testid": "menu-add-item-prev-step", customElevation: "skim", elevation: true },
            React__default.default.createElement(StepCustomizeWrapper, null,
                React__default.default.createElement(StepCustomizeContent, null,
                    React__default.default.createElement(Circle, null),
                    React__default.default.createElement(GroupItemName, null,
                        React__default.default.createElement(Text.Text, { color: "text_High_Emphasis", variant: "V2.body1.neutral.regular" }, selectedVariantName))),
                React__default.default.createElement("button", { onClick: onChangeLinkClick, "aria-label": jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.PREV_STEP_INFO_LABEL, groupName, selectedVariantName), "data-testid": "menu-add-item-change-button" },
                    React__default.default.createElement(Text.Text, { color: "primary", variant: "V2.body1.neutral.bold" }, "Change")))),
        React__default.default.createElement(Divider, null)));
};
var PrevStepInfo$1 = React__default.default.memo(PrevStepInfo);

const CustomizeContentV2 = (props) => {
    const { showToast, currentStep = 1, totalSteps, changeStep, selectedVariants, pricingModelHash, pricingModelKey, itemData, } = props;
    const getAddonGroups = () => {
        return props.validAddons;
    };
    const getSelectedVariant = (index) => {
        return props.selectedVariants[index];
    };
    const addonGroups = getAddonGroups();
    const variantGroups = props.validVariants;
    return (React__default.default.createElement(ContentContainer, { id: "customise-content" },
        React__default.default.createElement(PrevStepInfo$1, { currentStep: currentStep, changeStep: changeStep, selectedVariants: selectedVariants, variantGroups: variantGroups }),
        currentStep <= totalSteps ? (React__default.default.createElement(VariantGroup$1, { key: currentStep, variantGroup: variantGroups[currentStep - 1], onChange: props.updateVariant, groupIndex: currentStep - 1, selectedVariation: getSelectedVariant(currentStep - 1), showToast: showToast, showPrice: currentStep === totalSteps, pricingModelHash: pricingModelHash, pricingModelKey: pricingModelKey, itemData: itemData })) : (addonGroups.map((group, index) => {
            return (React__default.default.createElement(AddonGroup$1, { key: index, groupIndex: index, addonGroup: group, onAddonSelect: props.toggleAddon, selectedAddons: props.selectedAddons, showToast: showToast }));
        }))));
};
var ContentV4 = React__default.default.memo(CustomizeContentV2);

const CustomizeFooter = (props) => {
    const [showSelectionSummary, setShowSelectionSummary] = React.useState(false);
    const { state: { validAddons, selectedAddons, selectedVariants, variantsV2: { pricingModelHash }, pricingModelKey, item, currentStep, totalSteps, updatingExistingCustomization, }, dispatch, } = React.useContext(CustomizeContext.CustomizeContext);
    const toggleSelectionSummary = () => {
        setShowSelectionSummary((prev) => !prev);
    };
    const moveToNextStep = () => {
        dispatch(props.moveToNextStep());
    };
    const getPrice = () => {
        return utils.getV2Prices(validAddons, selectedAddons, pricingModelHash, pricingModelKey, item);
    };
    const price = getPrice();
    const showAddButton = currentStep > totalSteps || (totalSteps === currentStep && validAddons.length === 0);
    return !showAddButton ? (React__default.default.createElement(FooterContainer, { showSelectionSummary: showSelectionSummary },
        React__default.default.createElement(StepCutomizeFooter, null,
            React__default.default.createElement(Text.Text, { variant: "V2.subheading1.neutral.bold", color: "text_Highest_Emphasis" },
                "Step ",
                currentStep,
                "/",
                totalSteps),
            React__default.default.createElement(StyledButtonContainer, null,
                React__default.default.createElement(StyledButton, { variant: "positive", onClick: moveToNextStep, "data-testid": "menu-customize-continue-button", "aria-label": jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.FOOTER_V2_LABEL, currentStep, totalSteps) }, "Continue"))))) : (React__default.default.createElement(FooterContainer, { showSelectionSummary: showSelectionSummary && (!jsUtils.isEmpty(selectedAddons) || !jsUtils.isEmpty(selectedVariants)) },
        showSelectionSummary && (React__default.default.createElement(SelectionSummary$1, { selectedAddons: utils.getSelectedAddons(item, selectedAddons), selectedVariants: utils.getSelectedVariants(item, selectedVariants) })),
        React__default.default.createElement(AddButtonWrapper, null,
            React__default.default.createElement(CustomizeAddButton$1, { closeCustomize: props.closeCustomize, showSelectionSummary: showSelectionSummary, toggleSelectionSummary: toggleSelectionSummary, canGoBack: false, itemData: item, validAddons: validAddons, selectedAddons: selectedAddons, selectedVariants: selectedVariants, updatingExistingCustomization: updatingExistingCustomization, showToast: props.showToast, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem, price: price.price, finalPrice: price.finalPrice }))));
};
var Footer = React__default.default.memo(CustomizeFooter);

const CustomizeV2 = (props) => {
    const { state: { item, currentStep, selectedAddons, selectedVariants, totalSteps, validAddons, validVariants, pricingModelKey, variantsV2: { pricingModelHash }, }, } = React.useContext(CustomizeContext.CustomizeContext);
    return (React__default.default.createElement(CustomiseV1Container, { backgroundColor: props.backgroundColor },
        React__default.default.createElement(CustomiseContainer, null,
            React__default.default.createElement(Header.Header, { itemData: item, currentStep: currentStep }),
            React__default.default.createElement(ContentV4, { selectedAddons: selectedAddons, selectedVariants: selectedVariants, currentStep: currentStep, totalSteps: totalSteps, validAddons: validAddons, validVariants: validVariants, pricingModelKey: pricingModelKey, itemData: item, pricingModelHash: pricingModelHash, updateVariant: updateVariant, toggleAddon: toggleAddon, showToast: props.showToast, changeStep: changeStep }),
            React__default.default.createElement(Footer, { closeCustomize: props.closeCustomize, showToast: props.showToast, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem, moveToNextStep: moveToNextStep }))));
};
var CustomizeV2$1 = React__default.default.memo(CustomizeV2);

const Customize = (props) => {
    const { state: { version, currentStep }, } = React.useContext(CustomizeContext.CustomizeContext);
    if (jsUtils.isEmpty(props.item)) {
        return null;
    }
    return version === components_Customise_constants_index.CUSTOMIZE_VERSIONS.V2 ? (React__default.default.createElement(CustomizeV2$1, { closeCustomize: props.closeCustomize, showToast: props.showToast, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem, backgroundColor: props.backgroundColor })) : (React__default.default.createElement(CustomizeV1$1, { closeCustomize: props.closeCustomize, currentStep: currentStep, showToast: props.showToast, addCustomizeItem: props.addCustomizeItem, updateCustomizeItem: props.updateCustomizeItem, backgroundColor: props.backgroundColor }));
};
var Customize$1 = React__default.default.memo(Customize);

exports.Customize = Customize$1;
exports.showCustomizeModal = showCustomizeModal;
//# sourceMappingURL=Customise-Iyr7KqY2.js.map
